const middleware = {}

middleware['checkAuth'] = require('../middleware/checkAuth.js')
middleware['checkAuth'] = middleware['checkAuth'].default || middleware['checkAuth']

middleware['redirect-trailing-slash'] = require('../middleware/redirect-trailing-slash.js')
middleware['redirect-trailing-slash'] = middleware['redirect-trailing-slash'].default || middleware['redirect-trailing-slash']

export default middleware
